import React, { useState } from "react";
import styled from "styled-components";
import { sendContact, honeypotStyle } from "../utils/contactApi";

const FALLBACK_EMAIL = "info@nea.lu";

const Form = styled.form`
  display: flex;
  gap: 0.5rem;
  width: 100%;
  max-width: 26rem;

  @media screen and (max-width: 30em) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  min-width: 0;
  height: 48px;
  padding: 0 1.125rem;
  border-radius: var(--radius-full);
  border: 1px solid var(--ink-700);
  background: var(--ink-800);
  color: var(--text-inv);
  font-family: var(--fontR);
  font-size: 0.9375rem;

  &::placeholder {
    color: #8a8a90;
  }

  &:focus-visible {
    outline: 2px solid var(--green);
    outline-offset: 2px;
  }
`;

const Submit = styled.button`
  height: 48px;
  padding: 0 1.375rem;
  border: 1px solid #3a3a40;
  border-radius: var(--radius-full);
  background: transparent;
  color: var(--text-inv);
  font-family: var(--fontR);
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 150ms ease;

  &:hover {
    background: var(--ink-800);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

const Status = styled.p`
  margin-top: 0.75rem;
  font-family: var(--fontR);
  font-size: 0.8125rem;
  color: ${(props) => (props.$error ? "var(--amber)" : "#b4b4ba")};
`;

const NotifyForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [website, setWebsite] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus({ error: true, text: "Cette adresse email ne semble pas valide." });
      return;
    }

    setStatus({ pending: true, text: "Envoi…" });
    const result = await sendContact({ type: "android", email, website });
    if (result === "sent") {
      setEmail("");
      setStatus({ text: "C'est noté, on te prévient le jour de la sortie." });
      return;
    }
    if (result === "throttled") {
      setStatus({ error: true, text: "Trop de demandes d'un coup. Réessaie dans une minute." });
      return;
    }

    // The API could not take it: hand the request over to the visitor's mail app, nothing is silently dropped
    const subject = encodeURIComponent("Préviens-moi de la sortie Android");
    const body = encodeURIComponent(`Bonjour,\n\nPréviens-moi à la sortie de nea sur Android : ${email}\n`);
    window.location.href = `mailto:${FALLBACK_EMAIL}?subject=${subject}&body=${body}`;
    setStatus({ text: "Ton app mail s'ouvre : envoie le message et c'est noté." });
  };

  return (
    <div>
      <Form onSubmit={handleSubmit} noValidate>
        <Input
          type="email"
          name="email"
          autoComplete="email"
          placeholder="ton@email.com"
          aria-label="Ton adresse email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <input
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          style={honeypotStyle}
          value={website}
          onChange={(event) => setWebsite(event.target.value)}
        />
        <Submit type="submit" disabled={status?.pending}>
          Me prévenir
        </Submit>
      </Form>
      {status && (
        <Status role="status" $error={status.error}>
          {status.text}
        </Status>
      )}
    </div>
  );
};

export default NotifyForm;
